import React from "react";
import PdfViewer from "../../PdfViewer";

const AsignacionCuentasSegmentacionOportunidades = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/02-asignación-de-cuentas-y-segmentación-de-oportunidades.pdf`;
  /*const pdfUrl = "/pdf/02-asignación-de-cuentas-y-segmentación-de-oportunidades.pdf";*/

  return (
    <>
      <main>
        <div class="titulo">
          <h1>Asignación de Cuentas y Segmentación de Oportunidades</h1>
        </div>
        <div className="pdf-container">
          <PdfViewer pdfUrl={pdfUrl} />
        </div>
      </main>
    </>
  );
};

 export default AsignacionCuentasSegmentacionOportunidades;
